import axios from 'axios'
import airbrake from '@/helpers/airbrake'

const MIN_SEARCH_TERM_LENGTH = 4

export default {
  data () {
    return {
      isSearchLoading: false,
      searchTerm: '',
      selectedProvider: null,
      suggestions: []
    }
  },
  watch: {
    searchTerm (term) {
      if (term && term.length >= MIN_SEARCH_TERM_LENGTH) {
        this.isSearchLoading = true
        axios.get(`/suggest.json`, {params: {q: term.trim()}})
          .then(response => {
            this.isSearchLoading = false
            this.suggestions = response.data
          })
          .catch(err => {
            this.isSearchLoading = false
            this.suggestions = []
            airbrake.notify(err)
          })
      } else {
        this.suggestions = []
      }
    },
    selectedProvider (result) {
      if (result && result.url) {
        this.isSearchLoading = true
        window.location.href = result.url
      }
    }
  },
  methods: {
    searchProvider () {
      if (!(this.selectedProvider && typeof this.selectedProvider === 'object')) {
        // If search page, use vue-router
        if (this.$route && this.$route.name == 'search-index') {
          this.$router.push({
            name: 'search-index',
            query: { q: this.searchTerm }
          })
        } else {
          this.isSearchLoading = true
          window.location.assign(`/search?q=${encodeURIComponent(this.searchTerm || '')}`)
        }
      }
    },
    searchFilter (item) {
      return true
    }
  }
}



// WEBPACK FOOTER //
// ./frontend/src/mixins/provider-search.js